import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postTalkingPoint = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/briefs/talking-points`, data: payload });

  return data;
};

export default postTalkingPoint;
